import Store, { baseSkillsVariant } from '@/store'
import update from 'immutability-helper'
import _ from 'lodash'
import { useCallback } from 'react'
import { EditPlannerList } from '../utils/list'
import './edit.scss'

export function PlannerEditSkillSets() {
  const skills = Store.usePlanner((state) => state.skills)
  const dispatch = Store.useDispatch()

  const onAdd = () =>
    dispatch.setPlanner((planner) => {
      const lastSet = planner.skills.steps[planner.skills.steps.length - 1]?.skills ?? []
      return update(planner, {
        skills: {
          steps: {
            $push: [
              {
                name: '',
                skills: lastSet
              }
            ]
          },
          step: {
            $set: planner.skills.steps.length
          }
        }
      })
    })

  const onDelete = (index: number) =>
    dispatch.setPlanner((planner) => {
      const newPlanner = update(planner, {
        skills: {
          steps: {
            $splice: [[index, 1]]
          }
        }
      })

      const skills = newPlanner.skills
      if (skills.steps.length === 0) skills.steps = _.cloneDeep([baseSkillsVariant])
      if (skills.step === index) skills.step = skills.step - 1
      skills.step = Math.max(0, Math.min(skills.step, skills.steps.length - 1))

      return newPlanner
    })

  const onEditAttr = (index: number, newValue: string) =>
    dispatch.setPlanner((planner) => {
      return update(planner, {
        skills: {
          steps: {
            [index]: {
              name: { $set: newValue }
            }
          }
        }
      })
    })

  const onMove = useCallback(
    (from: number, to: number) =>
      dispatch.setPlanner((planner) => {
        const steps = planner.skills.steps
        const step = steps[from]
        return update(planner, {
          skills: {
            steps: {
              $splice: [
                [from, 1],
                [to, 0, step]
              ]
            }
          }
        })
      }),
    [dispatch]
  )

  const onClone = useCallback(
    (index: number) =>
      dispatch.setPlanner((planner) => {
        const steps = planner.skills.steps
        const step = steps[index]
        return update(planner, {
          skills: {
            steps: {
              $splice: [[index, 0, step]]
            }
          }
        })
      }),
    [dispatch]
  )

  return (
    <div className="poe-edit-skill-sets">
      <div className="poe-planner-modal-title">
        <span>Configure Skill Steps</span>
      </div>

      <div className="poe-planner-modal-body">
        <EditPlannerList
          items={skills.steps.map((step) => step.name)}
          onMove={onMove}
          onClone={onClone}
          onAdd={onAdd}
          onDelete={onDelete}
          onEdit={onEditAttr}
        />
      </div>
    </div>
  )
}
